import React, { useEffect } from 'react'
import useExecScripts from '../Component/useExecScripts'
import ContactEnquiryForm from '../Component/ContactEnquiryForm'

function Contact() {


	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="1272" className="elementor elementor-1272">
										<div className="elementor-element elementor-element-32ad4b9 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="32ad4b9" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-91daede e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="91daede" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
													<div className="elementor-element elementor-element-de1f017 elementor-widget elementor-widget-elementskit-heading" data-id="de1f017" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Get in Touch</h2></div></div>				</div>
													</div>
													<div className="elementor-element elementor-element-781bc06 elementor-widget" data-id="781bc06" data-element_type="widget" data-e-type="widget">
														<div className="elementor-widget-container">
															<div className="elementor-shortcode"><div className="mf-form-shortcode">
																<ContactEnquiryForm />
															</div></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-e496ad3 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="e496ad3" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-1f4e345 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="1f4e345" data-element_type="container" data-e-type="container">
													<div className="elementor-element elementor-element-cd3d3b3 elementor-widget elementor-widget-elementskit-heading" data-id="cd3d3b3" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">FAQs</h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div></div></div>				</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-dc3a312 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="dc3a312" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-63279c6 wpr-advanced-accordion-icon-no-box elementor-widget__width-inherit elementor-widget elementor-widget-wpr-advanced-accordion" data-id="63279c6" data-element_type="widget" data-e-type="widget" data-settings='{"active_item":1}' data-widget_type="wpr-advanced-accordion.default">
													<div className="elementor-widget-container">

														<div className="wpr-advanced-accordion" data-accordion-type="accordion" data-active-index="1" data-accordion-trigger="hover" data-interaction-speed="0.4">



															<div className="wpr-accordion-item-wrap">
																<button className="wpr-acc-button">
																	<span className="wpr-acc-item-title">
																		<span className="wpr-title-icon">
																		</span>

																		<span className="wpr-acc-title-text">How do I place my catering order?</span>
																	</span>
																	<span className="wpr-toggle-icon wpr-ti-close"><i aria-hidden="true" className="icon icon-down-arrow1"></i></span>
																	<span className="wpr-toggle-icon wpr-ti-open"><i aria-hidden="true" className="icon icon-up-arrow1"></i></span>
																</button>

																<div className="wpr-acc-panel">
																	<div className="wpr-acc-panel-content"><p><span style={{ fontWeight: '400' }}>Placing an order with TSR Catering &amp; Events is simple! You can call us, send a WhatsApp message, or fill out the enquiry form on our website. Our team will get in touch with you to discuss your requirements, customize the menu, and finalize the details.  </span></p></div>
																</div>
															</div>


															<div className="wpr-accordion-item-wrap">
																<button className="wpr-acc-button">
																	<span className="wpr-acc-item-title">
																		<span className="wpr-title-icon">
																		</span>

																		<span className="wpr-acc-title-text">What are the locations you cater to?</span>
																	</span>
																	<span className="wpr-toggle-icon wpr-ti-close"><i aria-hidden="true" className="icon icon-down-arrow1"></i></span>
																	<span className="wpr-toggle-icon wpr-ti-open"><i aria-hidden="true" className="icon icon-up-arrow1"></i></span>
																</button>

																<div className="wpr-acc-panel">
																	<div className="wpr-acc-panel-content"><p><span style={{ fontWeight: '400' }}>We cater to a wide range of locations, including Pune and surrounding areas. If you have a specific location in mind, feel free to reach out, and we’ll confirm our availability.  </span></p></div>
																</div>
															</div>


															<div className="wpr-accordion-item-wrap">
																<button className="wpr-acc-button">
																	<span className="wpr-acc-item-title">
																		<span className="wpr-title-icon">
																		</span>

																		<span className="wpr-acc-title-text">Can you cater to any venue?</span>
																	</span>
																	<span className="wpr-toggle-icon wpr-ti-close"><i aria-hidden="true" className="icon icon-down-arrow1"></i></span>
																	<span className="wpr-toggle-icon wpr-ti-open"><i aria-hidden="true" className="icon icon-up-arrow1"></i></span>
																</button>

																<div className="wpr-acc-panel">
																	<div className="wpr-acc-panel-content"><p><span style={{ fontWeight: '400' }}>Yes, we provide catering services at banquet halls, open lawns, corporate venues, private residences, and outdoor locations. We coordinate with venue management to ensure a seamless catering experience. </span></p></div>
																</div>
															</div>


															<div className="wpr-accordion-item-wrap">
																<button className="wpr-acc-button">
																	<span className="wpr-acc-item-title">
																		<span className="wpr-title-icon">
																		</span>

																		<span className="wpr-acc-title-text">Do you cater to any last-minute orders?</span>
																	</span>
																	<span className="wpr-toggle-icon wpr-ti-close"><i aria-hidden="true" className="icon icon-down-arrow1"></i></span>
																	<span className="wpr-toggle-icon wpr-ti-open"><i aria-hidden="true" className="icon icon-up-arrow1"></i></span>
																</button>

																<div className="wpr-acc-panel">
																	<div className="wpr-acc-panel-content"><p><span style={{ fontWeight: '400' }}>We always strive to accommodate last-minute orders based on availability. However, we recommend booking in advance to ensure we can provide the best service and menu options for your event.  </span></p></div>
																</div>
															</div>


															<div className="wpr-accordion-item-wrap">
																<button className="wpr-acc-button">
																	<span className="wpr-acc-item-title">
																		<span className="wpr-title-icon">
																		</span>

																		<span className="wpr-acc-title-text">When should I reserve my wedding catering service?</span>
																	</span>
																	<span className="wpr-toggle-icon wpr-ti-close"><i aria-hidden="true" className="icon icon-down-arrow1"></i></span>
																	<span className="wpr-toggle-icon wpr-ti-open"><i aria-hidden="true" className="icon icon-up-arrow1"></i></span>
																</button>

																<div className="wpr-acc-panel">
																	<div className="wpr-acc-panel-content"><p><span style={{ fontWeight: '400' }}>For weddings, we recommend booking your catering service at least 3 to 6 months in advance to secure your preferred date and menu. However, we do our best to accommodate shorter notice bookings based on availability.</span></p></div>
																</div>
															</div>

														</div>
													</div>
												</div>
											</div>
										</div>
									</div>



								</div>{/* .entry-content</div> */}
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default Contact

